<template>
    <div>
        <Loading :loading="$apollo.queries.translationsPage.loading" />
        <Navbar :languageList="translationsPage.languageList" />
        <v-fade-transition>
            <div v-show="!($apollo.queries.translationsPage.loading)">
            <v-container fluid>
                <v-layout row wrap align-center justify-start>
                    <v-flex grow>
                        <h1 class="display-1 font-weight-light">
                            We {{ searchQuery.length > 0 ? "found" : "have" }} {{ translationsPage.totalKeys - translationsPage.activeTranslations }} missing translations out of {{ translationsPage.totalKeys }} total keys for '{{ language }}' language
                        </h1>
                    </v-flex >
                    <v-flex shrink>
                        <v-container>
                            <v-layout row wrap align-center>
                                <v-flex>
                                    <v-text-field
                                        prepend-icon="search"
                                        append-icon="clear"
                                        @click:append="clearSearch"
                                        @keyup.enter="submitSearch"
                                        v-model="searchQuery2"
                                        outline
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-btn
                                        large
                                        @click="submitSearch"
                                        color="primary"
                                    >Search</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-tabs
                centered
                color="primary"
                slider-color="white"
                dark
                grow
            >
                <v-tab
                    v-for="{dict, active, total} in translationsPage.dicts"
                    :key="dict"
                    @click="setActiveDict(dict)"
                    :to="generateDictUrl(dict, searchQuery)"
                >{{ dict }} ({{ active }} / {{ total }})</v-tab>
            </v-tabs>
            <v-divider ></v-divider>
            <h1 v-if="translationsPage.keys.length === 0" class="text-xs-center display-1 my-4 font-weight-light">Nothing found</h1>
            <v-container
                fluid
                class="primary white--text px-4 py-4"
                v-if="translationsPage.keys.length > 0"
            >
                <v-layout row wrap align-center>
                    <v-flex sm3>
                        <h5 class="title font-weight-light">Key</h5>
                    </v-flex>
                    <v-flex sm3>
                        <h4 class="text-xs-center title font-weight-light">Active translation</h4>
                    </v-flex>
                    <v-flex sm3>
                        <h4 class="text-xs-center title font-weight-light">English translation</h4>
                    </v-flex>
                    <v-flex sm3>
                        <h4 class="text-xs-center title font-weight-light">Add translation</h4>
                    </v-flex>
                </v-layout>
            </v-container>
            <div v-for="{key, value, id, eng} in translationsPage.keys" :key="id">
                <v-container fluid class="px-4 py-2">
                    <v-layout row wrap justify-start >
                        <v-flex sm3>
                            <h6 class="title"
                                v-html="searchQuery.length > 0 ? highlightQuery(key) : key"
                            ></h6>
                            <br />
                            <v-btn
                                flat
                                icon
                                color="primary"
                                @click="deleteKey(id)"
                            >
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex sm3>
                            <p v-for="p in value.split('\n')" :key="p">
                                {{ p }}
                            </p>
                        </v-flex>
                        <v-flex sm3>
                            <p v-for="p in eng.split('\n')" :key="p">
                                {{ p }}
                            </p>
                        </v-flex>
                        <v-flex sm3>
                            <v-container fluid>
                                <v-layout>
                                    <v-flex grow>
                                        <v-textarea
                                            outline
                                            label="Translation"
                                            v-model="translationValues[id]"
                                            :rows="eng.split('\n').length"
                                            hide-details
                                            @focus="setToggledKey(id)"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex shrink>
                                        <v-btn
                                            large
                                            color="primary"
                                            :disabled="!translationValues[id]"
                                            @click="submitAdd(id, translationValues[id])"
                                        >Add</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-btn
                    flat
                    block
                    color="primary"
                    @click="toggleTranslation(id)"
                >{{ moreTranslations2[id] ? "Hide"  : "Show more" }}</v-btn>
                <v-divider></v-divider>
                <v-expand-transition>
                    <v-container
                        v-show="expandedKeys.includes(id)"
                        fluid
                        class="accent px-4 py-4"
                    >
                        <v-layout row wrap>
                            <v-flex xs12 sm7>
                                <h4 class="title font-weight-light">
                                    {{
                                        moreTranslations2[id] ?
                                            moreTranslations2[id].thisLang.length > 0 ?
                                                "Upvote best translation:"
                                                :
                                                "There's no translations yet"
                                            :
                                            "There's no translations yet"
                                    }}
                                </h4>
                                <v-container>
                                    <v-layout
                                        align-center
                                        justify-start
                                        v-for="{id: translationId, value, votes, isvoted, active, author} in moreTranslations2[id] ? moreTranslations2[id].thisLang : []"
                                        :key="translationId"
                                        class="my-2"
                                        row
                                        wrap
                                    >
                                        <v-flex grow>
                                            <p v-if="!(translationId in editedTranslations)"> {{ value }} </p>
                                            <v-textarea
                                                v-if="translationId in editedTranslations"
                                                outline
                                                rows="2"
                                                class="my-2"
                                                v-model="editedTranslations[translationId]"
                                                hide-details
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex shrink>{{ author }}</v-flex>
                                        <v-flex v-if="canEdit" shrink>
                                            <v-btn
                                                v-if="!(translationId in editedTranslations)"
                                                flat
                                                icon
                                                color="primary"
                                                @click="setEditedTranslation(translationId, value)"
                                            >
                                                <v-icon>edit</v-icon>
                                            </v-btn>
                                            <v-btn
                                                v-if="translationId in editedTranslations"
                                                flat
                                                icon
                                                color="primary"
                                                @click="saveEditedTranslation(id, translationId, true)"
                                            >
                                                <v-icon>save</v-icon>
                                            </v-btn>
                                            <br />
                                            <v-btn
                                                v-if="translationId in editedTranslations"
                                                flat
                                                icon
                                                @click="removeEditedTranslation(translationId)"
                                            >
                                                <v-icon>block</v-icon>
                                            </v-btn>
                                        </v-flex>
                                        <v-flex shrink>
                                            <v-btn
                                                flat
                                                color="primary"
                                                :disabled="isvoted"
                                                @click="voteTranslation(id, translationId)"
                                            >
                                                <v-icon left dark>thumb_up</v-icon>
                                                {{ votes}}
                                            </v-btn>
                                        </v-flex>
                                        <v-flex v-if="canApprove" shrink>
                                            <v-btn v-if="active" color="primary" disabled>
                                                Approved
                                            </v-btn>
                                            <v-btn
                                                v-if="!active"
                                                color="primary"
                                                @click="approveTranslation(id, translationId)"
                                            >Approve</v-btn>
                                        </v-flex>
                                        <v-flex v-if="canDelete" shrink>
                                            <v-btn
                                                color="primary"
                                                flat
                                                icon
                                                @click="deleteTranslation(id, translationId, true)"
                                            >
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                            <v-flex xs12 sm5>
                                <h4 class="title font-weight-light">
                                    {{
                                        moreTranslations2[id] ?
                                            moreTranslations2[id].otherLangs.length > 0 ?
                                                "Translations from other languages:"
                                                :
                                                "There's no translations from other languages"
                                            :
                                            "There's no translations from other languages"
                                    }}
                                </h4>
                                <v-container>
                                    <v-layout
                                        align-center
                                        v-for="{id: translationId, lang, author, value} in moreTranslations2[id] ? moreTranslations2[id].otherLangs : []"
                                        :key="translationId"
                                        class="my-2"
                                    >
                                        <v-flex xs2>
                                            <v-btn
                                                flat
                                                color="primary"
                                                @click="preciseSearch(key)"
                                                :to="`/translations/${lang}/${activeDict}?search=${searchQuery}`"
                                            >{{ lang }}</v-btn>
                                        </v-flex>
                                        <v-flex xs2>{{ author }}</v-flex>
                                        <v-flex grow>
                                            <p v-if="!(translationId in editedTranslations)"> {{ value }} </p>
                                            <v-textarea
                                                v-if="translationId in editedTranslations"
                                                outline
                                                rows="2"
                                                class="my-2"
                                                v-model="editedTranslations[translationId]"
                                                hide-details
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex v-if="canEdit" shrink>
                                            <v-btn
                                                v-if="!(translationId in editedTranslations)"
                                                flat
                                                icon
                                                color="primary"
                                                @click="setEditedTranslation(translationId, value)"
                                            >
                                                <v-icon>edit</v-icon>
                                            </v-btn>
                                            <v-btn
                                                v-if="translationId in editedTranslations"
                                                flat
                                                icon
                                                color="primary"
                                                @click="saveEditedTranslation(id, translationId, false)"
                                            >
                                                <v-icon>save</v-icon>
                                            </v-btn>
                                            <br />
                                            <v-btn
                                                v-if="translationId in editedTranslations"
                                                flat
                                                icon
                                                @click="removeEditedTranslation(translationId)"
                                            >
                                                <v-icon>block</v-icon>
                                            </v-btn>
                                        </v-flex>
                                        <v-flex v-if="canDelete" shrink>
                                            <v-btn
                                                color="primary"
                                                flat
                                                icon
                                                @click="deleteTranslation(id, translationId, false)"
                                            >
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-expand-transition>
            </div>
            <div class="text-xs-center my-4" v-if="translationsPage.totalPages > 1">
                <v-pagination
                    v-model="currentPage"
                    :length="translationsPage.totalPages"
                    :total-visible="11"
                    @input="updateUrl"
                ></v-pagination>
            </div>
            </div>
        </v-fade-transition>
        <v-snackbar
            v-model="showSnackbar"
            bottom
            right
            :timeout="6000"
         >{{ message }}</v-snackbar>
    </div>
</template>

<script>

import Navbar from "@/components/Navbar"
import Loading from "@/components/Loading"
import {
    TRANSLATIONS_PAGE,
    MORE_TRANSLATIONS,
    ADD_TRANSLATION,
    VOTE_TRANSLATION,
    APPROVE_TRANSLATION,
    EDIT_TRANSLATION,
    DELETE_TRANSLATION,
    DELETE_KEY } from "../graphql"

export default {
    components: {
        Navbar,
        Loading
    },
    apollo: {
        translationsPage: {
            query: TRANSLATIONS_PAGE,
            variables () {
                return {
                    lang: this.language,
                    dict: this.activeDict || "",
                    page: this.currentPage || 1,
                    searchQuery: this.searchQuery || ""
                }
            }
        },
        moreTranslations: {
            query: MORE_TRANSLATIONS,
            variables () {
                return {
                    lang: this.language,
                    keyId: this.toggledKey
                }
            },
            update (data) {
                this.moreTranslations2 = Object.assign(
                    {},
                    this.moreTranslations2,
                    { [this.toggledKey]: {
                        thisLang: data.moreTranslations.thisLang,
                        otherLangs: data.moreTranslations.otherLangs
                    } }
                )
            },
            skip () {
                return this.skipQuery
            }
        }
    },
    data () {
        const userScopes = this.$jwt.decode().Scopes || []
        return {
            translationValues: {},
            translationsPage: {
                keys: [],
                totalKeys: 0
            },
            language: this.$route.params.language,
            activeDict: this.$route.params.dict || "",
            currentPage: this.$route.query.page || 1,
            searchQuery: this.$route.query.search || "",
            searchQuery2: this.$route.query.search || "",
            totalPages: 0,
            expandedKeys: [],
            editedTranslations: {},
            moreTranslations2: {},
            toggledKey: null,
            showSnackbar: false,
            message: "",
            canApprove: userScopes.includes("translation-approve"),
            canEdit: userScopes.includes("translation-edit"),
            canDelete: userScopes.includes("translation-delete"),
            canDeleteKeys: userScopes.includes("key-delete"),
            skipQuery: true
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.language = to.params.language
        this.activeDict = to.params.dict
        this.currentPage = Number(to.query.page) || 1
        this.searchQuery = to.query.search || ""
        this.$apollo.queries.translationsPage.refetch()
        next()
    },
    methods: {
        toggleTranslation: function (key) {
            const eK = this.expandedKeys
            this.toggledKey = eK.includes(key) ? null : key // ??
            this.expandedKeys = eK.includes(key) ? eK.filter(t => t !== key) : eK.concat(key)

            if (!eK.includes(key)) {
                this.skipQuery = false
                this.$apollo.queries.moreTranslations.refetch()
            } else {
                this.skipQuery = true
                const { [key]: _, ...rest } = this.moreTranslations2
                this.moreTranslations2 = rest
            }
        },
        setToggledKey: function (key) {
            this.toggledKey = key
        },
        setActiveDict: function (dict) {
            this.currentPage = 1
            this.activeDict = dict
        },
        preciseSearch: function (key) {
            this.searchQuery = key
        },
        submitSearch: function () {
            this.$router.push({
                path: `/translations/${this.language}/${this.activeDict}?search=${this.searchQuery2}`
            })
            this.activeDict = ""
            this.currentPage = 1
            this.searchQuery = this.searchQuery2
        },
        voteTranslation: function (keyId, translationId) {
            const lang = this.language
            this.$apollo.mutate({
                mutation: VOTE_TRANSLATION,
                variables: {
                    lang,
                    keyId,
                    translationId
                },
                update: function (store, data) {
                    let d = store.readQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang }
                    })

                    store.writeQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang },
                        data: {
                            moreTranslations: {
                                thisLang: d.moreTranslations.thisLang.map(tL => tL.id === translationId
                                    ? { ...tL, votes: tL.votes + 1, isvoted: true } : { ...tL, isvoted: false, votes: tL.isvoted ? tL.votes - 1 : 0 }
                                ),
                                otherLangs: d.moreTranslations.otherLangs,
                                __typename: "moreTranslations"
                            }
                        }
                    })
                }
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
            })
        },
        approveTranslation: function (keyId, translationId) {
            const lang = this.language
            const dict = this.activeDict
            const page = this.currentPage
            const searchQuery = this.searchQuery

            this.$apollo.mutate({
                mutation: APPROVE_TRANSLATION,
                variables: {
                    lang,
                    keyId,
                    translationId
                },
                update: function (store, data) {
                    let mtState = store.readQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang }
                    })

                    store.writeQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang },
                        data: {
                            moreTranslations: {
                                thisLang: mtState.moreTranslations.thisLang.map(tL => ({ ...tL, active: tL.id === translationId })),
                                otherLangs: mtState.moreTranslations.otherLangs,
                                __typename: "moreTranslations"
                            }
                        }
                    })

                    let tpState = store.readQuery({
                        query: TRANSLATIONS_PAGE,
                        variables: { lang, dict, page, searchQuery }
                    })

                    const key = tpState.translationsPage.keys.find(k => k.id === keyId)
                    const thisLangTranslation = mtState.moreTranslations.thisLang.find(tL => tL.id === translationId)
                    const haveNoActive = mtState.moreTranslations.thisLang.every(tL => !tL.active)
                    const value = thisLangTranslation.value

                    if (key.value !== value) {
                        store.writeQuery({
                            query: TRANSLATIONS_PAGE,
                            variables: { lang, dict, page, searchQuery },
                            data: {
                                translationsPage: {
                                    keys: tpState.translationsPage.keys.map(k => k.id === keyId ? { ...k, value } : k),
                                    __typename: "translationsPage"
                                }
                            }
                        })
                    }
                    if (haveNoActive) {
                        store.writeQuery({
                            query: TRANSLATIONS_PAGE,
                            variables: { lang, dict, page, searchQuery },
                            data: {
                                translationsPage: {
                                    activeTranslations: tpState.translationsPage.activeTranslations + 1,
                                    dicts: tpState.translationsPage.dicts.map(d => d.dict === dict ? { ...d, active: d.active + 1 } : d),
                                    __typename: "translationsPage"
                                }
                            }
                        })
                    }
                }
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
            })
        },
        deleteTranslation: function (keyId, translationId, thisLang) {
            const lang = this.language
            const dict = this.activeDict
            const page = this.currentPage
            const searchQuery = this.searchQuery

            this.$apollo.mutate({
                mutation: DELETE_TRANSLATION,
                variables: {
                    translationId
                },
                update: function (store, data) {
                    let mtState = store.readQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang }
                    })
                    const subKey = thisLang ? "thisLang" : "otherLangs"
                    store.writeQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang },
                        data: {
                            moreTranslations: {
                                [subKey]: d.moreTranslations[subKey].filter(tL => tL.id !== translationId),
                                __typename: "moreTranslations"
                            }
                        }
                    })

                    let tpState = store.readQuery({
                        query: TRANSLATIONS_PAGE,
                        variables: { lang, dict, page, searchQuery }
                    })

                    const key = tpState.translationsPage.keys.find(k => k.id === keyId)
                    const thisLangTranslation = mtState.moreTranslations.thisLang.find(tL => tL.id === translationId)
                    const value = thisLangTranslation.value

                    if (key.value === value) {
                        store.writeQuery({
                            query: TRANSLATIONS_PAGE,
                            variables: { lang, dict, page, searchQuery },
                            data: {
                                translationsPage: {
                                    keys: tpState.translationsPage.keys.map(k => k.id === keyId ? { ...k, value: "" } : k),
                                    __typename: "translationsPage"
                                }
                            }
                        })
                    }
                    if (thisLangTranslation.active) {
                        store.writeQuery({
                            query: TRANSLATIONS_PAGE,
                            variables: { lang, dict, page, searchQuery },
                            data: {
                                translationsPage: {
                                    activeTranslations: tpState.translationsPage.activeTranslations - 1,
                                    dicts: tpState.translationsPage.dicts.map(d => d.dict === dict ? { ...d, active: d.active - 1 } : d),
                                    __typename: "translationsPage"
                                }
                            }
                        })
                    }
                }
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
            })
        },
        deleteKey: function (keyId) {
            if (!confirm("Are you sure?")) return
            const lang = this.language
            const dict = this.activeDict
            const page = this.currentPage
            const searchQuery = this.searchQuery

            this.$apollo.mutate({
                mutation: DELETE_KEY,
                variables: {
                    keyId
                },
                update: function (store, data) {
                    let d = store.readQuery({
                        query: TRANSLATIONS_PAGE,
                        variables: { lang, dict, page, searchQuery }
                    })
                    store.writeQuery({
                        query: TRANSLATIONS_PAGE,
                        variables: { lang, dict, page, searchQuery },
                        data: {
                            translationsPage: {
                                ...d.translationsPage,
                                keys: d.translationsPage.keys.filter(k => k.id !== keyId),
                                __typename: "keys"
                            }
                        }
                    })
                }
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
            })
        },
        submitAdd: function (keyId, translation) {
            const lang = this.language
            const author = this.$jwt.decode().Username
            this.$apollo.mutate({
                mutation: ADD_TRANSLATION,
                variables: {
                    lang: lang,
                    keyId: keyId,
                    translation: translation
                },
                update: function (store, data) {
                    let d = store.readQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang }
                    })
                    store.writeQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang },
                        data: {
                            moreTranslations: {
                                thisLang: d.moreTranslations.thisLang.concat({
                                    id: data.data.addTranslation.id,
                                    author: author,
                                    value: translation,
                                    votes: 0,
                                    active: false,
                                    isvoted: false,
                                    __typename: "thisLang"
                                }),
                                otherLangs: d.moreTranslations.otherLangs,
                                __typename: "moreTranslations"
                            }
                        }
                    })
                }
            }).then(data => {
                this.translationValues[keyId] = ""
                this.showSnackbar = true
                this.message = "New translation has been added successfully"
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
            })
        },
        generateDictUrl: function (dict, query) {
            return `/translations/${this.language}/${dict}${query.length > 0 ? `?search=${query}` : ""}`
        },
        updateUrl: function (i) {
            this.$router.push({
                path: `/translations/${this.language}/${this.activeDict || ""}?page=${i}${this.searchQuery.length > 0 ? `&search=${this.searchQuery}` : ""}`
            })
        },
        setEditedTranslation: function (id, value) {
            this.editedTranslations = {
                ...this.editedTranslations,
                [id]: value
            }
        },
        removeEditedTranslation: function (id) {
            const { [id]: _, ...rest } = this.editedTranslations
            this.editedTranslations = { ...rest }
        },
        saveEditedTranslation: function (keyId, translationId, thisLang) {
            const lang = this.language
            const value = this.editedTranslations[translationId]
            this.$apollo.mutate({
                mutation: EDIT_TRANSLATION,
                variables: {
                    value,
                    translationId
                },
                update: function (store, data) {
                    let d = store.readQuery({
                        query: MORE_TRANSLATIONS,
                        variables: { keyId, lang }
                    })
                    const subKey = thisLang ? "thisLang" : "otherLangs"
                    store.writeQuery({
                        query: MORE_TRANSLATIONS,
                        data: {
                            moreTranslations: {
                                [ subKey ]: d.moreTranslations[subKey].map(t => t.id === translationId ? Object.assign({}, t, { value }) : t),
                                __typename: "moreTranslations"
                            }
                        }
                    })
                }
            }).then(data => {
                this.editedTranslations = Object.keys(this.editedTranslations).filter(t => t !== translationId)
                const { [translationId]: _, ...rest } = this.editedTranslations
                this.editedTranslations = { ...rest }
                this.showSnackbar = true
                this.message = "Saved successfully"
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
            })
        },
        clearSearch: function () {
            this.searchQuery = ""
            this.searchQuery2 = ""
        },
        highlightQuery: function (text) {
            return text.replace(new RegExp(this.searchQuery, "gi"), match => `<span style="background-color: yellow;">${match}</span>`)
        }
    }
}

</script>
